import { CloseOutlined, DeleteOutlined, EyeInvisibleOutlined, EyeOutlined, PlusOutlined, SyncOutlined } from "@ant-design/icons"
import { Button, Form, Input, Modal, Select, TreeSelect } from "antd"
import { useForm } from "antd/es/form/Form"
import { FormProps } from "antd/lib"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { editSmsConfig, InfoSmsConfig } from "../../../../../api/generalConfiguration/generalConfigurationApi"
import { getCLCategoryCar } from "../../../../../api/selectOption/selectOptionsApi"
import { getSLSmsProvider, getSLUnitByPermission, ISelectOption } from "../../../../../api/selectOptions/selectOptionsApi"
import useThrottle from "../../../../../hook/useThrottle"
import { selectorCategoryCarIds } from "../../../../../store/slices/categoryCarSlice"
import { selectorUnitByUserPermission } from "../../../../../store/slices/UnitByUserPermission"
import { fommatSelectOption, fommatSelectOptionUnitByUser } from "../../../../../until"
import '../../styles.scss'
import { selectorInfoUser } from "../../../../../store/slices/infoUserSlice"
import { convertNationwideValueToTree_V2 } from "../../../../../api/unit/unitApi"

interface IBrandRow {
    id: string;
    brandName: string | undefined;
    carBrand: string | undefined;
    type: string | undefined;
}

let counter = 0;

const generateId = () => crypto.randomUUID();

interface ModalProps {
    isOpen: boolean
    infoSmsConfig?: InfoSmsConfig
    onSubmitFormModal: (iSsuccess: boolean, errorMessage?: string) => void
    closeModal: (e: boolean) => void
}
const ModalUpdateSMSProvider: React.FC<ModalProps> = ({
    isOpen, onSubmitFormModal, closeModal, infoSmsConfig,
}) => {

    useEffect(() => {
        let unmounted = false;
        (async () => {
            const [resNationwide] = await Promise.all([getSLUnitByPermission(unitTemp),
            ]);
            if (!unmounted && resNationwide?.status) setSLNationwide(convertNationwideValueToTree_V2(resNationwide.data));
        })();

    }, []);

    const { unitTemp, id } = useSelector(selectorInfoUser)

    const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)
    const unitByUserPermissionSlice = useSelector(selectorUnitByUserPermission)

    const [form] = useForm();

    const [sLProvider, setSLProvider] = useState<ISelectOption[]>([])
    const [sLCategoryCar, setSLCategoryCar] = useState<ISelectOption[]>([])
    const [sLNationwide, setSLNationwide] = useState<any>()

    //#region gọi api SL OP
    const gSLProvider = async () => {
        const result = await getSLSmsProvider()
        if (result?.status) {
            setSLProvider(fommatSelectOption(result.data))
        }
    }

    const gSLCategoryCar = async () => {
        const result = await getCLCategoryCar(
            undefined, undefined, permittedCategoryCarIds
        )
        if (result?.status) {
            setSLCategoryCar([
                { label: "Tất cả", value: -1 },
                ...fommatSelectOption(result.data)
            ])
        }
    }
    //#endregion

    const onFinish: FormProps["onFinish"] = useThrottle(async (values: any) => {
        if (!infoSmsConfig) return;
     const { username, password, brandConfigs, providerId, apiEndpointCSKH, apiEndpointQC } = values

        const result = await editSmsConfig(
            infoSmsConfig.id,  providerId, apiEndpointCSKH, apiEndpointQC, username, password,
            brandConfigs
        )

        if (result?.status) {
            onSubmitFormModal?.(true, result?.message)
        } else {
            onSubmitFormModal?.(false, result?.message)
        }
    }, 1000)

    useEffect(() => {
        if (isOpen) {
            form.resetFields();
            if (!sLProvider.length)
                gSLProvider()
            if (sLCategoryCar.length < 2)
                gSLCategoryCar()

            if (infoSmsConfig) {
                const {
                    providerId,
                    
                } = infoSmsConfig;

                form.setFieldsValue({
                    apiEndpointQC: infoSmsConfig.apiEndpointQC,
                    apiEndpointCSKH: infoSmsConfig.apiEndpointCSKH,
                    username: infoSmsConfig.username,
                    password: infoSmsConfig.password,
                    providerId,
                    brandConfigs: (infoSmsConfig.brandConfigs || []).map(item => ({
                        brandName: item.brandName,
                        categoryCarIds: item.categoryCarIds,
                        messageType: item.messageType,
                        phoneNumber: item.phoneNumber,
                        unitIds: item.unitIds
                    }))
                });
            }
        }
    }, [isOpen, infoSmsConfig]);




    return (

        <Form
            form={form}
            onFinish={onFinish}
            style={{ display: 'contents' }}
        >
            <Modal
                title={<div className="bg-FCFCFD d-flex justify-betweeen align-center pb-4  w-full border-b-F0F0F0  overflow-hidden">
                    <span className="text-base text-344054 fw-500 font-medium">Tạo nhà cung cấp SMS</span>
                    <CloseOutlined className="text-base text-8B8B8B" onClick={() => closeModal(false)} />
                </div>}
                open={isOpen}
                onCancel={() => closeModal(false)}
                centered
                className="custom-modal-ant-history"
                closeIcon={false}
                destroyOnClose
                footer={<div className="bg-FCFCFD d-flex justify-betweeen align-center pt-2  w-full border-t-F0F0F0">
                    <span className="text-sm text-98A2B3 cursor-pointer"
                        onClick={() => closeModal(false)}
                    >Huỷ</span>
                    <button
                        className="text-white text-sm bg-096DD9 border-none shadow-btn-save rounded-2 h-8 px-15-px"
                        onClick={() => form.submit()}>
                        Lưu
                    </button>
                </div>}
            >
                <div className="custom-modal-ant-history-child custom-page-css flex flex-col max-h-65vh overflow-y-scroll gap-2 py-2">
                    <div className="d-flex flex-column gap-1">
                        <p className="text-sm  font-regular text-344054 ">
                            Nhà cung cấp:<span className="text-F5222D">*</span>
                        </p>
                        <Form.Item
                            name="providerId"
                            rules={[{ required: true, message: 'Chọn tên nhà cung cấp!' }]}
                            className="m-none-form-item text-explan text-label"
                        >
                            <Select
                                className="custom-page-css border rounded overflow-hidden"
                                placeholder="Tên Nhà cung cấp"
                                options={sLProvider}
                            />
                        </Form.Item>
                    </div>
                     <div className="d-flex flex-column gap-1">
                        <p className="text-sm  font-regular text-344054 ">
                            API Endpoint CSKH:<span className="text-F5222D">*</span>
                        </p>
                        <Form.Item
                            name="apiEndpointCSKH"
                            rules={[{ required: true, message: 'Nhập API Endpoint CSKH!' }]}
                            className="m-none-form-item text-explan"
                        >
                            <Input
                                placeholder="API Endpoint CSKH"
                                className=" custom-input-css"
                            />
                        </Form.Item>
                    </div>
                    <div className="d-flex flex-column gap-1">
                        <p className="text-sm  font-regular text-344054 ">
                            API Endpoint Quảng cáo:<span className="text-F5222D">*</span>
                        </p>
                        <Form.Item
                            name="apiEndpointQC"
                            rules={[{ required: true, message: 'Nhập API Endpoint Quảng cáo!' }]}
                            className="m-none-form-item text-explan"
                        >
                            <Input
                                placeholder="API Endpoint Quảng cáo"
                                className=" custom-input-css"
                            />
                        </Form.Item>
                    </div>
                    <div className="custom-page-css grid grid-cols-2 gap-4">
                        <div className="d-flex flex-column gap-1">
                            <p className="text-sm  font-regular text-344054 ">
                                Username:<span className="text-F5222D">*</span>
                            </p>
                            <Form.Item
                                name="username"
                                rules={[{ required: true, message: 'Nhập Username!' }]}
                                className="m-none-form-item text-explan"
                            >
                                <Input
                                    placeholder="Username"
                                    className=" custom-input-css"
                                />
                            </Form.Item>
                        </div>
                        <div className="d-flex flex-column gap-1">
                            <p className="text-sm  font-regular text-344054 ">
                                Password:<span className="text-F5222D">*</span>
                            </p>
                            <Form.Item
                                name="password"
                                rules={[{ required: true, message: 'Nhập Password!' }]}
                                className="m-none-form-item text-explan"
                            >
                                <Input.Password
                                    className="custom-input-css"
                                    placeholder="Password"
                                    iconRender={(visible) =>
                                        visible ? <EyeOutlined /> : <EyeInvisibleOutlined />
                                    }
                                />
                            </Form.Item>
                        </div>
                    </div>
                    <Button
                        className="custom-page-css w-fit text-096DD9 border-096DD9"
                    >
                        <SyncOutlined />
                        Đồng bộ brandname
                    </Button>
                    <Form.List name="brandConfigs">
                        {
                            (fields, { add, remove }) => (
                                <div className="custom-page-css bg-white rounded pb-2">

                                    {/* HEADER */}
                                    <div className="custom-page-css grid grid-cols-1fr_2fr_2fr_2fr_2fr_2fr gap-4 bg-E6F7FF p-3 font-medium">
                                        <div>Hành động</div>
                                        <div>Brandname</div>
                                        <div>Thương hiệu hãng xe</div>
                                        <div>Loại tin</div>
                                        <div>Số điện thoại để gửi</div>
                                        <div>Phạm vi hoạt động</div>
                                    </div>

                                    {/* ROWS */}
                                    {
                                        fields.map(({ key, name, ...restField }) => (
                                            <div
                                                key={key}
                                                className="custom-page-css grid grid-cols-1fr_2fr_2fr_2fr_2fr_2fr gap-4 items-center py-3 px-3 "
                                            >
                                                {/* ACTION */}
                                                <div
                                                    className="w-full custom-page-css flex flex-col items-center"

                                                >
                                                    <Button
                                                        className="w-fix custom-page-css flex flex-col items-center border rounded"
                                                        style={{
                                                            textAlign: 'center'
                                                        }}
                                                        type="text"
                                                        disabled={fields.length <= 1}
                                                        danger
                                                        icon={<DeleteOutlined />}
                                                        onClick={() => remove(name)}
                                                    />
                                                </div>
                                                {/* BRAND NAME */}
                                                <Form.Item
                                                    {...restField}
                                                    name={[name, "brandName"]}
                                                    rules={[{ required: true, message: "Chọn Brandname" }]}
                                                    className="custom-page-css m-0 overflow-hidden"
                                                >
                                                    <Input
                                                        className="custom-input-css custom-page-css py-1"
                                                        placeholder="Brandname"
                                                    />
                                                </Form.Item>

                                                {/* CAR BRAND */}
                                                <Form.Item
                                                    {...restField}
                                                    className="custom-page-css h-full overflow-hidden border rounded"
                                                    name={[name, "categoryCarIds"]}
                                                    rules={[{ required: true, message: "Chọn hãng xe" }]}

                                                >
                                                    <Select
                                                        mode="multiple"
                                                        className="custom-scroll-multi-select"
                                                        showSearch={false}
                                                        placeholder="Chọn hãng xe"
                                                        options={sLCategoryCar}
                                                        onChange={(values) => {
                                                            if (!values) return;
                                                            const fieldPath = ["brandConfigs", name, "categoryCarIds"];
                                                            const hasAll = values.includes(-1);
                                                            if (hasAll && values.length > 1) {
                                                                // Nếu có -1 và có thêm cái khác
                                                                // Kiểm tra xem -1 vừa được chọn hay vừa bị bỏ
                                                                const onlyAll = values[values.length - 1] === -1;
                                                                form.setFieldValue(
                                                                    fieldPath,
                                                                    onlyAll ? [-1] : values.filter((v: number) => v !== -1)
                                                                );
                                                            }
                                                        }}
                                                    />
                                                </Form.Item>

                                                {/* TYPE */}
                                                <Form.Item
                                                    {...restField}
                                                    name={[name, "messageType"]}
                                                    rules={[{ required: true, message: "Chọn loại tin" }]}
                                                    className="custom-page-css m-0 overflow-hidden border rounded"
                                                >
                                                    <Select
                                                        placeholder="Chọn loại tin"
                                                        options={[
                                                            { label: "Chăm sóc khách hàng", value: "Chăm sóc khách hàng" },
                                                            { label: "Quảng cáo", value: "Quảng cáo" },
                                                        ]}
                                                    />
                                                </Form.Item>
                                                {/* SDT */}
                                                <Form.Item
                                                    {...restField}
                                                    name={[name, "phoneNumber"]}
                                                    className="custom-page-css m-0 overflow-hidden"
                                                    rules={[
                                                        { required: true, message: "Nhập số điện thoại" },
                                                        {
                                                            validator(_, value) {
                                                                if (!value) return Promise.resolve()

                                                                if (!/^0\d{9}$/.test(value)) {
                                                                    return Promise.reject(
                                                                        new Error("Số điện thoại không hợp lệ (10 số, bắt đầu bằng 0)")
                                                                    )
                                                                }
                                                                return Promise.resolve()
                                                            }
                                                        }
                                                    ]}
                                                >
                                                    <Input
                                                        className="custom-input-css custom-page-css py-1"
                                                        placeholder="Số điện thoại để gửi"
                                                    />
                                                </Form.Item>
                                                {/* TYPE */}
                                                <Form.Item
                                                    {...restField}
                                                    name={[name, "unitIds"]}
                                                    rules={[{ required: true, message: "Chọn phạm vi hoạt động" }]}
                                                    className="custom-page-css m-0 overflow-hidden border rounded"
                                                >
                                                    <TreeSelect
                                                        className={'custom-scroll-multi-select custom-page-css border rounded overflow-hidden'}
                                                        showSearch
                                                        multiple
                                                        placeholder="Chọn phạm vi hoạt động"
                                                        allowClear
                                                        treeDefaultExpandAll={false}
                                                        treeData={sLNationwide}
                                                        filterTreeNode={(input: string, option: any) =>
                                                            typeof option?.label === 'string' && option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                        }
                                                    />
                                                </Form.Item>
                                            </div>
                                        ))
                                    }
                                    {/* ADD BUTTON */}
                                    <Button
                                        type="primary"
                                        icon={<PlusOutlined />}
                                        className="custom-page-css mt-2 ml-3"
                                        onClick={() =>
                                            add({
                                                brandName: undefined,
                                                carBrand: undefined,
                                                type: undefined,
                                            })
                                        }
                                    >
                                        Thêm brandname
                                    </Button>
                                </div>
                            )
                        }
                    </Form.List>
                </div>
            </Modal>
        </Form>
    )
}
export default ModalUpdateSMSProvider
